import React from 'react';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
// import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import { WithStyles, withStyles } from '@material-ui/core/styles';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link as RouterLink, match, RouteComponentProps } from 'react-router-dom';

// Components
import { Anchor } from '../../../components/anchor';
// import { AnchorBlock } from '../../../components/anchorBlock';
import App from '../../../components/app';
import { Dialog } from '../../../components/dialog';
import ErrorMessage from '../../../components/error-message';
import { AutoFill } from '../../../components/field-autofill';
import EnhancedListItem from '../../../components/listItem';
import { TooltipButton } from '../../../components/tooltip-button';
import { Typobold } from '../../../components/typobold';
import { LCAlert } from '../../../components/alert';
import { ActionLogs } from '../../../components/action-logs';
import { SentMessages } from '../../../components/sent-messages';
import FormSubmit from '../../../components/form/formSubmit';
import { ActionFunction, FormatType, ListCell } from '../../../local-types';
// Modules
import {
    Rider,
    RiderAverage,
    RiderById,
    CompanyMembership,
    AccountType,
    TParams,
} from '../../../redux/reducers/api-types';
import { actions as errorActions, ErrorPayload, selectors as errorSelectors } from '../../../redux/reducers/errors';
import {
    actions as riderActions,
    selectors as riderSelectors,
    types as riderTypes,
} from '../../../redux/reducers/riders';
// Ressources
import DateUtils from '../../../utils/dateUtils';
import FormattingUtils from '../../../utils/formattingUtils';
import FormUtils from '../../../utils/forms';
import ObjectUtils from '../../../utils/objectUtils';
import StringUtils from '../../../utils/stringUtils';
import UserUtils, { AccountRight, RightRank } from '../../../utils/userUtils';
import styles from './rider-view-style';
import { createPath, paths } from '../../paths';
import ChartsUtils from '../../../utils/chartsUtils';
import { getBanReason } from '../../../utils/businessUtils';
import { getListCompaniesURL } from '../../../utils/core-api';
import { clsx } from '../../../utils/htmlUtils';
import envConfig from '../../../config';

interface RiderViewProps extends WithTranslation, WithStyles, RouteComponentProps {
    match: match<TParams>;
    riders: RiderById;
    getRiderError: ErrorPayload;
    clearError: (errorType: string) => void;
    editRiderError: ErrorPayload;
    impersonateUserError: ErrorPayload;
    getRider: (id: string) => void;
    editRider: (id: string, payload: any, onDone: Function) => void;
    anonRider: (id: string, ok: boolean) => void;
    patchRider: (id: string, payload: any, onDone: Function) => void;
    resetRiderPassword: (email: string, callback: React.EffectCallback) => void;
    changeRiderCompany: (id: string, idCompany: any) => void;
    setAdminCompany: (id: string | number, idCompany: any, payload: any) => void;
    impersonateUser: (id: string, callback: React.EffectCallback) => void;
}

interface RiderViewState {
    formData: any;
    initFormData: any;
    formCredit: any;
    modeChangeCompany: boolean;
    text: string;
    idc: any;
}

class RiderViewPage extends React.Component<RiderViewProps, RiderViewState> {
    canActions: boolean = UserUtils.checkRights({
        name: AccountRight.RIDER_PROFILE,
        mode: RightRank.W,
    });
    canChangeCompanySettings: boolean = UserUtils.checkRights({
        name: AccountRight.COMPANY_SETTINGS,
        mode: RightRank.W,
    });
    canCreatePromo: boolean = UserUtils.checkRights({
        name: AccountRight.PROMO_DETAILS,
        mode: RightRank.W,
    });
    canImpersonate: boolean =
        UserUtils.checkRights({
            name: AccountRight.SEC_IMPERSONATE,
            mode: RightRank.R,
        }) ||
        UserUtils.checkRights({
            name: AccountRight.SEC_IMPERSONATE_EXTENDED,
            mode: RightRank.R,
        });

    alertRef: any;

    state = {
        formData: {} as any,
        initFormData: {},
        formCredit: {} as any,
        modeChangeCompany: false,
        text: '',
        idc: -1,
    };

    componentDidMount() {
        this.load();
    }

    load = (): void => {
        // A failure recorded for the entity we come from would otherwise greet the next
        // one with the retry panel instead of the loader.
        this.props.clearError(riderTypes.GET_RIDER);

        const id = this.props.match.params.id;

        if (!this.props.riders[id]) {
            this.props.getRider(id);
        }
    };

    static getDerivedStateFromProps(props, state) {
        const id = props.match.params.id;
        const riderPayload = props.riders[id];
        if (riderPayload && !state.formData.id) {
            return {
                formData: ObjectUtils.deepCopy(riderPayload),
                initFormData: ObjectUtils.deepCopy(riderPayload),
                formCredit: { id, account_type: AccountType.PERSO, amount: '', text: '' },
            };
        }
        return null;
    }

    //====================================//
    //=============== This ===============//
    //====================================//
    bookingsOptions: Highcharts.Options = null;

    //=============================================//
    //=============== Event Handler ===============//
    //=============================================//

    handleChange = (event) => {
        this.setState(FormUtils.nextSubState(event, this.state, 'formCredit'));
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const { formData } = this.state;
        const id = this.props.match.params.id;

        const payload = {
            obp: formData.obp,
            vip: formData.vip,
            banned: formData.banned,
            ban_description: !formData.banned ? '' : formData.ban_description,
        };

        this.props.editRider(id, payload, () => {
            delete this.state.formData.obp;
            delete this.state.formData.vip;
            this.setState({
                initFormData: this.state.formData,
            });
        });
    };

    handleChangeCompanySubmit = (event) => {
        event.preventDefault();
        const { idc } = this.state;
        const id = this.props.match.params.id;
        if (idc > 0) {
            this.props.changeRiderCompany(id, idc);
        }
    };

    handleSubmitCredit = (event) => {
        event.preventDefault();
        const id = this.props.match.params.id;
        this.props.patchRider(id, this.state.formCredit, () => {
            this.setState({
                formCredit: { id, account_type: AccountType.PERSO, amount: '', text: '' },
            });
        });
    };

    handleAnon = (ok: boolean) => () => {
        const id = this.props.match.params.id;
        this.props.anonRider(id, ok);
    };

    openCompanyChange = () => {
        this.setState((prevState) => ({
            modeChangeCompany: !prevState.modeChangeCompany,
        }));
    };

    handleChangeFormData = (event) => {
        this.setState(FormUtils.nextSubState(event, this.state, 'formData'));
    };

    handleSetCompanyAdmin = (riderPayload: Rider) => (e) => {
        this.props.setAdminCompany(riderPayload.id, riderPayload.active_company_membership.company?.id, {
            admin: !riderPayload.active_company_membership.admin,
        });
    };

    handleImpersonateUser = (riderPayload: Rider) => (e) => {
        this.props.impersonateUser(riderPayload.uuid, () => {
            UserUtils.setImpersonateInfos(window.location.href);
            window.location.href = `${envConfig.webapp_rider_url}`;
        });
    };

    //=============================================//
    //=============== Graph Methods ===============//
    //=============================================//

    getPickupDate(date: Date): number {
        date.setHours(0, 0, 0, 0);
        return date.getTime();
    }

    getResults(bookings_recent): any {
        const { cancelled, ride_ended, others } = bookings_recent.reduce(
            (all, { creation_date, status: s }) => {
                const status = s === 'cancelled' || s === 'ride_ended' ? s : 'others';
                const ts = this.getPickupDate(new Date(creation_date.date));
                const found = all[status].find((item) => item.ts === ts);
                if (!found) {
                    all[status].push({ ts, val: 1 });
                } else {
                    found.val++;
                }
                return all;
            },
            { cancelled: [], ride_ended: [], others: [] },
        );
        return {
            cancelled: cancelled.map(Object.values),
            ended: ride_ended.map(Object.values),
            others: others.map(Object.values),
        };
    }

    createGraph = (payload): void => {
        const { t } = this.props;

        if (!payload || !payload.bookings_recent || payload.bookings_recent.length <= 0) {
            return;
        }

        const { cancelled, ended, others } = this.getResults(payload.bookings_recent);

        // Load bookings Graph
        this.bookingsOptions = null;

        const bookings_per_app: Highcharts.SeriesOptionsType[] = [
            {
                name: t('booking:booking_status_cancelled'),
                type: 'line',
                data: cancelled,
            },
            {
                name: t('booking:booking_status_ride_ended'),
                type: 'line',
                data: ended,
            },
            { name: t('graph.others'), type: 'line', data: others },
            // { 'name': t('graph.drive'), 'type': 'line', 'data': courses }
        ];

        this.bookingsOptions = ChartsUtils.createBookingsChart(t, bookings_per_app);
    };

    /**
     * An average with the number of rides or ratings it is based on, so an average
     * computed on 2 rides is not read like one computed on 200
     */
    renderAverage = (average: RiderAverage, format: (value: number) => string, basisKey: string): string => {
        const { t } = this.props;
        if (average?.value === null || average?.value === undefined) {
            return null;
        }
        return `${format(average.value)} ${t(basisKey, { count: average.count })}`;
    };

    generateListItem = (riderPayload): ListCell[] => {
        const { t } = this.props;
        if (!riderPayload) {
            return [];
        }

        const listItem: ListCell[] = [
            { title: t('common:form.id'), data: riderPayload.id, readOnly: true },
            { title: t('common:form.firstname'), data: riderPayload.firstname },
            { title: t('common:form.lastname'), data: riderPayload.lastname },
            { title: t('common:form.email'), data: riderPayload.email, copyable: true },
            {
                title: t('common:form.phone_number'),
                data: riderPayload.phone_number,
                type: FormatType.Phone,
                copyable: true,
            },
            {
                title: t('common:form.lang'),
                readOnly: true,
                data: riderPayload.lang && StringUtils.upperFirst(riderPayload.lang),
            },
            {
                title: t('fraud_score'),
                readOnly: true,
                data: riderPayload.fraud_score,
                customStyle: FormattingUtils.fraudscoreToStyle(riderPayload.fraud_score),
                optional: true,
            },
            {
                title: t('subscription_date'),
                readOnly: true,
                data: riderPayload.subscription_date,
                type: FormatType.DateLong,
            },
            {
                title: t('default_booking_address'),
                readOnly: true,
                data: riderPayload.default_booking_address,
                type: FormatType.Address,
                optional: true,
            },
            // {
            //     title: t('total_net_30'),
            //     readOnly: true,
            //     data: riderPayload.total_net_price_without_vat_generated_recently,
            //     type: FormatType.Price,
            // },
            // {
            //     title: t('total_net'),
            //     readOnly: true,
            //     data: riderPayload.total_net_price_without_vat,
            //     type: FormatType.Price,
            // },
            {
                title: t('recent_invoice'),
                readOnly: true,
                data: (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.billsSimple}?filters[user_id]=${riderPayload.uuid}`}
                    >
                        {t('common:click_to_see')}
                    </Link>
                ),
            },
            {
                title: t('promotions.title'),
                readOnly: true,
                data: this.renderPromotionsViews(riderPayload),
                optional: true,
            },
            {
                title: t('company'),
                data: this.renderCompanyMembershipsViews(riderPayload),
                optional: true,
            },
            {
                title: t('nb_reservations'),
                readOnly: true,
                data: !!riderPayload.nb_reservations ? (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.reservations}?filters[rider.id]=${riderPayload.id}`}
                    >{`${riderPayload.nb_reservations} (${t('common:click_to_see')})`}</Link>
                ) : null,
                optional: true,
            },
            {
                title: t('nb_bookings'),
                readOnly: true,
                data: !!riderPayload.nb_bookings ? (
                    <Link
                        color="secondary"
                        component={RouterLink}
                        to={`${paths.bookings}?filters[rider.id]=${riderPayload.id}`}
                    >{`${riderPayload.nb_bookings} (${t('common:click_to_see')})`}</Link>
                ) : null,
                optional: true,
            },
            {
                title: t('averages.rating_given'),
                readOnly: true,
                data: this.renderAverage(
                    riderPayload.averages?.rating_given,
                    (value) => `${value} / 5`,
                    'averages.rating_basis',
                ),
                optional: true,
            },
            {
                title: t('averages.spending_perso'),
                readOnly: true,
                data: this.renderAverage(
                    riderPayload.averages?.spending_perso,
                    (value) => FormattingUtils.price(value, true),
                    'averages.rides_basis',
                ),
                optional: true,
            },
            {
                title: t('averages.spending_pro'),
                readOnly: true,
                data: this.renderAverage(
                    riderPayload.averages?.spending_pro,
                    (value) => FormattingUtils.price(value, true),
                    'averages.rides_basis',
                ),
                optional: true,
            },
            {
                title: t('grants'),
                readOnly: true,
                data: this.renderGrantsViews(riderPayload),
                optional: true,
            },
            {
                title: t('common:form.additional_infos'),
                data: riderPayload.additional_info,
                optional: true,
            },
        ];

        return listItem;
    };

    getActions = (riderPayload: Rider): any[] => {
        const { t } = this.props;
        const actions: ActionFunction[] = [];
        if (this.canCreatePromo) {
            actions.push({
                label: t('promotions.create'),
                func: () =>
                    this.props.history.push(
                        createPath(paths.ridersPromotion, { id: (this.props.match.params as any).id }),
                    ),
            });
        }
        // if (this.canActions) {
        //     actions.push({
        //         label: t('common:reset_password'),
        //         func: () =>
        //             this.props.resetRiderPassword(riderPayload.email, () => {
        //                 this.alertRef.showAlert();
        //             }),
        //     });
        // }
        return actions;
    };

    generateAppHeader = (riderPayload: Rider): any => {
        const { t } = this.props;
        return {
            icon: 'default',
            title: riderPayload?.fullname,
            subtitle: riderPayload && `ID: ${riderPayload.id}`,
            bubble: {
                visible: riderPayload?.banned || riderPayload?.booking_suspended,
                text: t('common:suspended'),
                tooltip: riderPayload?.booking_suspended ? t('booking_suspended') : t('driver:ban_reason.manual'),
            },
            actions: this.getActions(riderPayload),
            anchors: [
                { href: '#bookings_graph', label: t('graph.bookings') },
                { href: '#general_infos', label: t('common:form.general_infos') },
                { href: '#additional_infos', label: t('common:form.additional_infos') },
                { href: '#sent_messages', label: t('sent_messages:title') },
                // { href: '#credit', label: t('credit.title') },
                // { href: '#credits_logs', label: t('credits_logs') },
            ],
        };
    };

    //======================================//
    //=============== Render ===============//
    //======================================//

    renderGrantsViews = (riderPayload: Rider): JSX.Element[] => {
        const { grants } = riderPayload;
        if (grants.length > 0) {
            return grants.map((item, index) => (
                <ListItemText key={index}>
                    {DateUtils.tsToDate(item.creation_date, false)}
                    {`\t-\t${item.consumer.description}`}
                </ListItemText>
            ));
        }
        return null;
    };

    renderPromotionsViews = (riderPayload: Rider): JSX.Element[] => {
        const { t } = this.props;
        const { promotions } = riderPayload;

        if (!promotions?.length) {
            return null;
        }

        return promotions
            .sort((a, b) => Number(b.is_active) - Number(a.is_active))
            .map(({ promotion, is_active }, index) => (
                <TooltipButton
                    key={index}
                    title={promotion?.description || ''}
                    style={{ marginBottom: 4, width: '100%' }}
                >
                    <ListItemText>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                fontWeight: is_active ? 'bold' : 'normal',
                            }}
                        >
                            <span>{promotion?.code || promotion?.name}</span>
                            <div>
                                <span style={{ marginRight: 8 }}>
                                    {`${t('promotions.use_limit')}: ${promotion?.use_limit}`}
                                </span>
                                <span
                                    style={{
                                        color: is_active ? '#4caf50' : '#f44336',
                                        padding: '2px 8px',
                                        borderRadius: 4,
                                        backgroundColor: is_active
                                            ? 'rgba(76, 175, 80, 0.5)'
                                            : 'rgba(244, 67, 54, 0.5)',
                                    }}
                                >
                                    {' '}
                                </span>
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: 12,
                                marginTop: 4,
                                fontSize: '0.8em',
                                opacity: 0.75,
                            }}
                        >
                            {/* <span>
                                {`${t('promotions.creation_date')}: ${DateUtils.tsToDate(promotion?.creation_date, true)}`}
                            </span>
                            <span>
                                {`${t('promotions.use_date')}: ${DateUtils.tsToDate(promotion?.use_date, true)}`}
                            </span> */}
                            <span>
                                {`${t('promotions.expiration_date')}: ${DateUtils.tsToDate(promotion?.expiration_date, true)}`}
                            </span>
                        </div>
                    </ListItemText>
                </TooltipButton>
            ));
    };

    renderCompanyMembershipsViews = (riderPayload: Rider): JSX.Element[] => {
        const { t } = this.props;
        const { company_memberships } = riderPayload;
        if (company_memberships.length > 0) {
            return company_memberships
                .filter((c) => c.status !== 'ended')
                .map((cmp, index) => (
                    <ListItemText key={index}>
                        <Link color="secondary" component={RouterLink} to={`${paths.companies}/${cmp.company.id}`}>
                            {cmp.company.name}
                        </Link>
                        {`\t (${t('company_status.' + cmp.status)})`}
                        {cmp.department?.id && (
                            <>
                                {` - ${t('department')} : `}
                                <Link
                                    color="secondary"
                                    component={RouterLink}
                                    to={`${paths.companies}/${cmp.department.id}`}
                                >
                                    {cmp.department.name}
                                </Link>
                            </>
                        )}
                    </ListItemText>
                ));
        }
        return null;
    };

    renderCreditLogsRows = (riderPayload: Rider): JSX.Element[] => {
        return riderPayload.credit_logs.map(({ admin, date, account_type, id, amount, text }) => {
            const respo = StringUtils.userFullname(admin);
            return (
                <TableRow key={id}>
                    <TableCell component="th" scope="row">
                        {DateUtils.tsToDate(date, true)}
                    </TableCell>
                    <TableCell>{account_type}</TableCell>
                    <TableCell>{FormattingUtils.price(amount)}</TableCell>
                    <TableCell align="center">{text}</TableCell>
                    <TableCell align="right">{respo}</TableCell>
                </TableRow>
            );
        });
    };

    renderFormCredit = (riderPayload: Rider): JSX.Element => {
        const { formCredit } = this.state;
        const { t, classes } = this.props;
        return (
            formCredit.id && (
                <FormSubmit debounceSubmit={{ callback: this.handleSubmitCredit }}>
                    <Anchor id="credit" />
                    <Typobold>{t('credit.title')}</Typobold>
                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                        <CardContent>
                            <Typography variant="subtitle1" component="p">
                                {t('credit.hint')}
                            </Typography>
                            <Typography variant="subtitle2" component="p">{`${t('credit.available')} - ${'\t'}${t(
                                'credit.type.perso',
                            )}: ${FormattingUtils.price(riderPayload.credit_perso, true)}  /  ${t(
                                'credit.type.pro',
                            )}: ${FormattingUtils.price(riderPayload.credit_pro, true)}`}</Typography>
                            <div className={classes.formInputs}>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="account_type">{t('credit.type.title')}</InputLabel>
                                    <Select
                                        native
                                        id="account_type"
                                        name="account_type"
                                        value={formCredit.account_type}
                                        className={classes.formInput}
                                        required={true}
                                        onChange={this.handleChange}
                                    >
                                        <option value={AccountType.PERSO}>{t('credit.type.perso')}</option>
                                        <option value={AccountType.PRO}>{t('credit.type.pro')}</option>
                                    </Select>
                                </FormControl>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="amount">{t('credit.amount')}</InputLabel>
                                    <Input
                                        id="amount"
                                        name="amount"
                                        value={formCredit.amount}
                                        type="number"
                                        className={classes.formInput}
                                        required={true}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                                <FormControl margin="dense">
                                    <InputLabel htmlFor="text">{t('credit.motive')}</InputLabel>
                                    <Input
                                        id="text"
                                        name="text"
                                        value={formCredit.text}
                                        className={classes.formInput}
                                        onChange={this.handleChange}
                                    />
                                </FormControl>
                            </div>
                        </CardContent>
                        <CardActions className={classes.rightActions}>
                            <Button type="submit" variant="contained">
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    </Card>
                </FormSubmit>
            )
        );
    };

    renderChangeCompany = (riderPayload: Rider): JSX.Element => {
        const { modeChangeCompany, text } = this.state;
        const { t, classes } = this.props;
        return (
            modeChangeCompany && (
                <FormSubmit debounceSubmit={{ callback: this.handleChangeCompanySubmit }}>
                    <Typobold>{t('change_company')}</Typobold>
                    <Card className={clsx(classes.card, classes.partnerInfo)}>
                        <CardContent>
                            <List>
                                <ListItem style={{ textAlign: 'center', flex: 1 }}>
                                    <AutoFill
                                        datas={{
                                            id: 'newCompany',
                                            label: t('new_company'),
                                            minChar: 1,
                                            style: { width: '100%' },
                                            formData: this.state,
                                            variant: 'outlined',
                                            onChange: (idc, text) => {
                                                this.setState({ idc, text });
                                            },
                                            loaderPosition: 'right',
                                            api: getListCompaniesURL(),
                                        }}
                                    />
                                </ListItem>
                            </List>
                        </CardContent>
                        <CardActions>
                            <Button
                                type="submit"
                                variant="contained"
                                color={
                                    text.length === 0 ||
                                    riderPayload.company_memberships.findIndex((c) => c.company.name === text) !== -1
                                        ? 'inherit'
                                        : 'secondary'
                                }
                            >
                                {t('common:validate')}
                            </Button>
                        </CardActions>
                    </Card>
                    <br />
                </FormSubmit>
            )
        );
    };

    renderCompanyMemberships = (riderPayload: Rider): JSX.Element => {
        const { formData } = this.state;
        const { t, classes } = this.props;
        if (!formData?.company_memberships || formData.company_memberships.length === 0) {
            return null;
        }

        return (
            <>
                <div>{t('company_type.obp_hint')}</div>
                {formData.company_memberships.map((cmp: CompanyMembership, index) => {
                    return (
                        <ListItem key={index}>
                            <div style={{ marginRight: 8 }} className={classes.partnerInfoLabel}>
                                {cmp.company.name}
                            </div>
                            {cmp.status === 'ended' && (
                                <div style={{ marginRight: 20 }} className={classes.partnerWarningLabel}>
                                    {t('company_status.ended')}
                                </div>
                            )}
                            <TooltipButton title={t('company_type.obp_desc')}>
                                <FormLabel>{t('company_type.obp')}</FormLabel>
                            </TooltipButton>
                            <FormControl margin="dense">
                                <Checkbox
                                    style={{ marginLeft: 8 }}
                                    edge="start"
                                    checked={cmp.onboard_payment}
                                    disabled={
                                        cmp.department
                                            ? !cmp.department.centralized_payment
                                            : !cmp.company?.centralized_payment
                                    }
                                    onChange={() => {
                                        cmp.onboard_payment = !cmp.onboard_payment;
                                        const nextFormData = { ...formData };
                                        if (
                                            riderPayload.company_memberships[index].onboard_payment ===
                                            cmp.onboard_payment
                                        ) {
                                            delete nextFormData.obp;
                                        } else {
                                            nextFormData.obp = cmp.company.id;
                                        }
                                        this.setState({
                                            formData: nextFormData,
                                        });
                                    }}
                                    tabIndex={-1}
                                />
                            </FormControl>

                            <TooltipButton title={t('company_type.vip_desc')}>
                                <FormLabel>{t('company_type.vip')}</FormLabel>
                            </TooltipButton>
                            <FormControl margin="dense">
                                <Checkbox
                                    style={{ marginLeft: 8 }}
                                    edge="start"
                                    checked={cmp.vip}
                                    onChange={() => {
                                        cmp.vip = !cmp.vip;
                                        const nextFormData = { ...formData };
                                        if (riderPayload.company_memberships[0].vip === cmp.vip) {
                                            delete nextFormData.vip;
                                        } else {
                                            nextFormData.vip = cmp.company.id;
                                        }
                                        this.setState({
                                            formData: nextFormData,
                                        });
                                    }}
                                    tabIndex={-1}
                                />
                            </FormControl>
                        </ListItem>
                    );
                })}
            </>
        );
    };

    renderListItems = (riderPayload: Rider): JSX.Element => {
        const { formData } = this.state;
        const { t, classes } = this.props;
        return (
            <>
                {riderPayload.booking_suspended && (
                    <ListItem style={{ color: 'red' }}>{t('booking_suspended_desc')}</ListItem>
                )}
                <ListItem>
                    <FormLabel className={classes.partnerInfoLabel}>{t('common:suspended')}</FormLabel>
                    <FormControl margin="dense">
                        <Checkbox
                            style={{ marginLeft: 8 }}
                            edge="start"
                            checked={formData.banned}
                            name={'banned'}
                            onChange={this.handleChangeFormData}
                            tabIndex={-1}
                        />
                    </FormControl>
                    {riderPayload.banned && (
                        <div>
                            {t('driver:ban_reason.title')}
                            {' : '}
                            {getBanReason(t, riderPayload)}
                        </div>
                    )}

                    {formData.banned && (
                        <>
                            <FormLabel style={{ marginLeft: 16 }} className={classes.partnerInfoLabel}>
                                {t('driver:ban_description.title')}
                            </FormLabel>
                            <FormControl margin="dense">
                                <FormGroup row={true}>
                                    <Input
                                        style={{ marginLeft: 8 }}
                                        id={'ban_description'}
                                        type={'text'}
                                        placeholder={t('driver:ban_description.placeholder')}
                                        name={'ban_description'}
                                        value={formData.ban_description || ''}
                                        className={classes.formInput}
                                        onChange={this.handleChangeFormData}
                                    />
                                </FormGroup>
                            </FormControl>
                        </>
                    )}
                </ListItem>
            </>
        );
    };

    render() {
        const { formData, initFormData } = this.state;
        const { t, match, riders, classes, getRiderError, editRiderError } = this.props;
        const id = match.params.id;
        const riderPayload = riders[id];

        this.createGraph(riderPayload);

        return (
            <App
                needRights={{ name: AccountRight.RIDER_PROFILE, mode: RightRank.R }}
                loading={!riderPayload}
                loadingError={this.props.getRiderError}
                onRetry={this.load}
                header={this.generateAppHeader(riderPayload)}
            >
                <ErrorMessage payload={getRiderError} />
                <ErrorMessage payload={editRiderError} />
                <ErrorMessage payload={this.props.impersonateUserError} />
                <LCAlert
                    onRef={(ref) => (this.alertRef = ref)}
                    details={t('login:forgot_password_sent')}
                    type="success"
                />
                {riderPayload && (
                    <>
                        <Anchor id="bookings_graph" />
                        {this.bookingsOptions && (
                            <HighchartsReact highcharts={Highcharts} options={this.bookingsOptions} />
                        )}
                        <br />
                        <Anchor id="general_infos" />
                        {riderPayload.photo_url && (
                            <Avatar alt="Avatar" src={riderPayload.photo_url} className={classes.bigAvatar} />
                        )}
                        <EnhancedListItem
                            datas={this.generateListItem(riderPayload)}
                            title={t('common:form.general_infos')}
                            cardActions={
                                <>
                                    {this.canImpersonate && (
                                        <Button
                                            color="secondary"
                                            variant="contained"
                                            onClick={this.handleImpersonateUser(riderPayload)}
                                        >
                                            {t('common:impersonate.action')}
                                        </Button>
                                    )}
                                    {(this.canChangeCompanySettings || this.canActions) && (
                                        <>
                                            {this.canActions && (
                                                <>
                                                    {!riderPayload.anonymized && (
                                                        <Dialog
                                                            btnTitle={t('remove_infos')}
                                                            description={t('remove_infos_desc')}
                                                            onOK={this.handleAnon(true)}
                                                        />
                                                    )}
                                                    {riderPayload.anonymized === 2 && (
                                                        <Dialog
                                                            btnTitle={t('remove_infos_cancel')}
                                                            description={t('remove_infos_cancel_desc')}
                                                            onOK={this.handleAnon(false)}
                                                        />
                                                    )}
                                                </>
                                            )}
                                            {this.canChangeCompanySettings && (
                                                <>
                                                    {/* {riderPayload?.company_memberships?.length > 0 && <Button size="small" color="secondary" variant='contained' onClick={this.openCompanyChange}>{t('change_company')}</Button>} */}
                                                    <Button
                                                        color="secondary"
                                                        variant="contained"
                                                        onClick={this.openCompanyChange}
                                                    >
                                                        {t('change_company')}
                                                    </Button>
                                                    {riderPayload.active_company_membership && (
                                                        <Button
                                                            color="secondary"
                                                            variant="contained"
                                                            onClick={this.handleSetCompanyAdmin(riderPayload)}
                                                        >
                                                            {t(
                                                                riderPayload.active_company_membership.admin
                                                                    ? 'admin.remove'
                                                                    : 'admin.set',
                                                            )}
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                            {this.canActions && (
                                                <Button
                                                    color="secondary"
                                                    variant="contained"
                                                    component={RouterLink}
                                                    to={createPath(paths.ridersEdit, { id })}
                                                >
                                                    {t('common:edit')}
                                                </Button>
                                            )}
                                        </>
                                    )}
                                </>
                            }
                        />
                        <br />
                        {this.renderChangeCompany(riderPayload)}
                        {this.canChangeCompanySettings && formData.id && (
                            <FormSubmit debounceSubmit={{ callback: this.handleSubmit }}>
                                <Anchor id="additional_infos" />
                                <Typobold>{t('common:form.additional_infos')}</Typobold>
                                <Card className={clsx(classes.card, classes.partnerInfo)}>
                                    <CardContent>
                                        <List>
                                            {this.renderListItems(riderPayload)}
                                            {formData.company_memberships.length > 0 && <hr />}
                                            {this.renderCompanyMemberships(riderPayload)}
                                        </List>
                                    </CardContent>
                                    <CardActions>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            color={
                                                ObjectUtils.isEqual(formData, initFormData) ? 'inherit' : 'secondary'
                                            }
                                        >
                                            {t('common:validate')}
                                        </Button>
                                    </CardActions>
                                </Card>
                            </FormSubmit>
                        )}
                        {/* <br />
                        {this.renderFormCredit(riderPayload)}
                        <br />
                        <AnchorBlock
                            id="credits_logs"
                            title={t('credits_logs')}
                            items={
                                riderPayload?.credit_logs ? (
                                    <Table className={classes.table} size="small" aria-label="Table credit logs">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>{t('date')}</TableCell>
                                                <TableCell>{t('type')}</TableCell>
                                                <TableCell>{t('amount')}</TableCell>
                                                <TableCell align="center">{t('reason')}</TableCell>
                                                <TableCell align="right">{t('respo')}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>{this.renderCreditLogsRows(riderPayload)}</TableBody>
                                    </Table>
                                ) : null
                            }
                        /> */}
                        <SentMessages uuid={riderPayload.uuid} />
                        <ActionLogs history={riderPayload.history} withValues />
                    </>
                )}
            </App>
        );
    }
}

const RiderViewPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['rider', 'driver', 'booking', 'common'])(RiderViewPage),
);

const mapStateToProps = (state) => ({
    riders: riderSelectors.riders(state),
    getRiderError: errorSelectors.getRiderError(state),
    editRiderError: errorSelectors.editRiderError(state),
    impersonateUserError: errorSelectors.impersonateUserError(state),
});

const mapDispatchToProps = {
    clearError: errorActions.clearError,
    getRider: riderActions.getRider,
    editRider: riderActions.editRider,
    anonRider: riderActions.anonRider,
    patchRider: riderActions.patchRider,
    resetRiderPassword: riderActions.resetRiderPassword,
    changeRiderCompany: riderActions.changeRiderCompany,
    setAdminCompany: riderActions.setAdminCompany,
    impersonateUser: riderActions.impersonateUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(RiderViewPageWithStyleAndTranslation);
